import dynamic from "next/dynamic";

export const DynamicImage = dynamic(() => import("./component"));
